import modular from './modular/modular';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import { gsap } from 'gsap';

const app = new modular({
    modules: modules
});

window.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
window.isAndroid = /(android)/i.test(navigator.userAgent);

if (window.isMobile) {
    html.classList.add('is-mobile');
} else {
    html.classList.add('is-desktop');
}
if(window.isMobile) {
    if(window.innerWidth > 1000) {
        window.isTablet = true;
    }
}

if(window.isAndroid) {
	html.classList.add('is-android');
}

window.isWindows = navigator.platform.indexOf('Win') > -1;

if(window.isWindows) {
    html.classList.add('is-windows');
}

window.isIos = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
if(window.isIos) {
    html.classList.add('is-ios');
}

window.onload = (event) => {
    init();
};

window.firstHit = true;
window.readyDelay = 0.3;
window.readyCallbackDelay = 1;
window.isVisiting = false;

if (
	window.location.href.indexOf('dev.vendredi-society.fr') > -1 ||
	window.location.href.indexOf('vendredi-society.local') > -1 ||
	window.location.href.indexOf('dev.vendredi-society.com') > -1 ||
	window.isMobile ||
	document.querySelector('#swup').getAttribute('data-template') != 'home'
) {
	window.hasSeenLoader = true;
} else {
	// desactivate loader with a true here 
	window.hasSeenLoader = false;
}


// if true, you'll need to this.call('setFirstLoad','Load');
window.needToWait = true;

function init() {
			
	// Credits
	console.log(
		"\n%cMade by Vendredi Society",
		"color:#fff;font-size:12px;font-weight: 700;padding:10px 15px; margin: 0.3rem auto 1.3rem auto; font-family: Metropolis, Helvetica, sans-serif;background-color:#F0FF3D;color: #002921; border-radius: 6px;"
	);
	console.log(
		"\n%cBack-end development: Leia Casteigbou \n Front-end development: Quentin Hocdé https://quentinhocde.com - https://twitter.com/quentinhocde, https://instagram.com/quentin_internet",
		"color:#fff;font-size:12px; padding:10px 15px; margin: 0.3rem auto 1.3rem auto; font-family: Metropolis, Helvetica, sans-serif;background-color:#003D31;border-radius: 6px;"
	);
	console.log(
		"\n%c",
		"color:#fff;font-size:12px; padding:10px 15px; margin: 0.3rem auto 1.3rem auto; font-family: Metropolis, Helvetica, sans-serif;background-color:#003D31;border-radius: 6px;"
	);

    globals();

    app.init(app);

    html.classList.add('is-loaded');
    html.classList.remove('is-loading');

    if (!window.needToWait) {
        gsap.delayedCall(window.readyDelay, () => {
            html.classList.add("is-ready");
            html.classList.add("has-dom-ready");

            gsap.delayedCall(window.readyCallbackDelay, () => {
                html.classList.add("has-dom-ready-callback");
                html.classList.add("has-dom-animated");

                window.firstHit = false;
            });
        });
    } else {
        html.classList.add("is-first-load");
        // gsap.delayedCall(window.readyDelay, () => {
        //     html.classList.add("is-first-load");
        // });
    }
}

